import React, { Dispatch, ReactElement, useEffect, useState } from 'react'
import rainLayer from "../assets/rainLayer.png";
import { useMapLayersContext } from '../provider/MapLayers';
import { LocationMarkerPopup } from "../mainLayer/MainWindow";

type LayerRainProbabilityPropsType = {
  name: string;
  color?: string;
}

const LayerRainProbability = (props: LayerRainProbabilityPropsType) => {
  const { selectLayerInMap, loadLayerInMap, setIsRainProbabilityLoad } = useMapLayersContext();
  const [isSelectedRain, setIsSelectedRain] = useState<boolean>(false)

  useEffect(() => {
    if (loadLayerInMap === "rainProbability") {
      setIsSelectedRain(true);
    } else if (loadLayerInMap !== "rainProbability") {
      setIsSelectedRain(false);
    }
  }, [loadLayerInMap]);


  const RainIconClick = () => {
    if (loadLayerInMap !== "rainProbability") {
      setIsSelectedRain(prevState => !prevState);
      setIsRainProbabilityLoad(false);
    }
    if (isSelectedRain === true) {
      selectLayerInMap("rainProbabilitynot");
      setIsRainProbabilityLoad(false);
    }
  };

  useEffect(() => {
    if (isSelectedRain) {
      selectLayerInMap("rainProbability");
    } else {
      LocationMarkerPopup("rainProbability");
    }
  }, [isSelectedRain]);

  return (
    <div className={`subItemWrapper`} onClick={(e) => RainIconClick()} onTouchStart={(e) => RainIconClick()}>
      {props.color && (
        <div className={`colorBox ${isSelectedRain ? 'selected' : ''}`} style={{ backgroundColor: `${props.color}` }}></div>
      )}

      <div className={`colorBox ${isSelectedRain ? 'selected' : ''}`}>
        <img src={rainLayer} alt="" />
      </div>

      <span>{props.name}</span>

    </div>
  )
}

export default LayerRainProbability;